<h2 mat-dialog-title>Transaction History</h2>

<mat-divider></mat-divider>

<mat-dialog-content>
    <invoice-history [invoices]="invoices">
    </invoice-history>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="stretch center">
    <button mat-button mat-dialog-close telemetry="Submission-Close-Invoices-PurchaseOrder">
        Close
    </button>
</mat-dialog-actions>